// extracted by mini-css-extract-plugin
export default {"content":"modal_content__LKJPu","overlay":"modal_overlay__+jqTW","close_btn":"modal_close_btn__fs5yB"};